import Icon from '@chegg-wt/core/components/Icon'
import styled from 'styled-components'
import {
  Large,
  SpecialButtonLink,
  SpecialOutlineButton,
} from '@chegg-wt/core/theme/fanta/button'
import { values } from '@chegg-wt/core/theme/sunkist/spacing'
import { Body } from '@chegg-wt/core/theme/sunkist/typography'
import { font } from '@chegg-ui/theme'

export const MessageIcon = styled(Icon)<{ name: string }>`
  height: ${values.xlarge};
  width: ${values.xlarge};
  margin: 0;
  color: ${({ theme }) => theme.Colors.forInterface.interfaceColor26};
`

export const MessageText = styled.div`
  ${Body};
  margin-left: ${values.xxsmall};
  margin-top: ${values.xxsmall};
`

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  height: 50px;
`
export const Button = styled(SpecialButtonLink)`
  ${Large};
  padding: 0;
  text-align: center;
  width: 300px;
  cursor: pointer;
  border-color: ${({ theme }) => theme.Colors.primaryColor};
  background-color: ${({ theme }) => theme.Colors.primaryColor};
  &:hover {
    border-color: ${({ theme }) => theme.Colors.forFonts.fColor16};
    background-color: ${({ theme }) => theme.Colors.forFonts.fColor16};
  }
`

export const OutlineButton = styled(SpecialOutlineButton)`
  width: 300px;
`

export const Header = styled.div`
  font-weight: ${font.weight.bold};
  font-size: ${font.size.px32};
`

export const SubHeader = styled.div`
  font-weight: 400;
  font-size: ${font.size.px16};
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  margin-top: 40px;
`

export const ButtonContainerWrapper = styled.div`
  margin-top: 33px;
  padding-bottom: 10px;
`
